const BET_MENTOR_PORTAL_CONTAINER_CLASS = 'BetMentorPortalContainer';

function isAltenarPopup(element: Element): boolean {
  return element instanceof HTMLElement && element.className.includes(BET_MENTOR_PORTAL_CONTAINER_CLASS);
}

function centreAltenarPopup(element: HTMLElement): void {
  element.style.position = 'relative';
  element.style.top = 'auto';
  element.style.marginTop = 'auto';
  element.style.marginBottom = 'auto';
  element.style.maxWidth = '100%';
}

function centreAltenarPopups(root: ParentNode): void {
  root.querySelectorAll('div').forEach(node => {
    if (!isAltenarPopup(node)) {
      return;
    }

    centreAltenarPopup(node);
  });
}

export { centreAltenarPopup, centreAltenarPopups, isAltenarPopup };
